import { IdNameObjectType } from "./global-configuration-state.model";

export const GlobalConfig_Enums_STATE_PATH = 'enums';

export class GlobalConfigurationEnumsStateModel {
	trackingSystems?: IdNameObjectType[];
	handleMode?: string[];
	actions?: IdNameObjectType[];
	cmpOnHoldReasons?: IdNameObjectType[];
	receiveFromClient?: IdNameObjectType[];
	origins?: IdNameObjectType[];
	productTypes?: IdNameObjectType[];
	inspectionTypes?: IdNameObjectType[];
	uad36FieldTypes?: IdNameObjectType[];
	retryActions?: any;
	lastUpdate?: number;

	constructor() {
		this.trackingSystems = [];
		this.handleMode = [];
		this.retryActions = {};
		this.lastUpdate = 0;
	}
}
